import { Link } from "react-router-dom";
// import logo from '../../images/tbiti_logo.png'
import Shape1 from "../../images/mail.svg";
import News1 from "../../images/phone.svg";
import News2 from "../../images/map.svg";
import servicesData from "../../api/Services.js";
import ProductsData from "../products/productsData.js";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = (props) => {
  return (
    <footer
      className="wpo-site-footer"
      style={{ padding: 0, width: "100vw", minWidth: "100%" }}
    >
      <div
        className="wpo-upper-footer mb-3"
        style={{ paddingTop: "0.5vw", paddingBottom: 0 }}
      >
        <div className="container " style={{ margin: "0 auto" }}>
          <div
            className="row justify-content-center gx-2 gy-2"
            style={{
              paddingTop: "0.5vw",
              display: "flex",
              flexWrap: "wrap",
              gap: "0px",
            }}
          >
            {/* <div className=" col-lg-1 col-md-6 col-sm-12 col-12"></div> */}
            <div className=" col-lg-3 col-md-6 col-sm-12 col-12 mt-4 px-4">
              <div className="widget link-widget ps-sm-5">
                <div className="widget-title">
                  <h5>Explore</h5>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/services">
                      Services
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/products">
                      Products
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/career">
                      Careers
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className=" col-lg-3 col-md-6 col-sm-12 col-12 mt-4 px-4">
              <div className="widget link-widget s2">
                <div className="widget-title">
                  <h5>Services</h5>
                </div>
                <ul>
                  {/* <li>
                    <Link onClick={ClickHandler} to="/service-single/1">
                      Web App Development
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/service-single/2">
                      Mobile App Development
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/service-single/3">
                      UI/UX
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/service-single/4">
                      Cloud Infrastructure
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/service-single/5">
                      IT Staffing
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/service-single/6">
                      Offshore Development
                    </Link>
                  </li> */}
                  {servicesData.map((service) => (
                    <li key={service.Id}>
                      <Link
                        onClick={ClickHandler}
                        to={`/services/${service.slug}`}
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className=" col-lg-3 col-md-6 col-sm-12 col-12 mt-4 px-4">
              <div className="widget link-widget s2">
                <div className="widget-title">
                  <h5>Products</h5>
                </div>
                <ul>
                  {/* <li>
                    <Link onClick={ClickHandler} to="/product-single/erp">
                      ERP System
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/product-single/crm">
                      CRM Platform
                    </Link>
                  </li>

                  <li>
                    <Link onClick={ClickHandler} to="/product-single/elearning">
                      E-Learning Platform
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/product-single/cargo">
                      Cargo Management System
                    </Link>
                  </li> */}
                     {ProductsData.map((product) => (
                          <li key={product.Id}>
                            <Link to={`/products/${product.slug}`}>{product.title}</Link>
                          </li>
                        ))}
                </ul>
              </div>
            </div>

            <div className=" col-lg-3 col-md-6 col-sm-12 col-12 mt-4 px-4 ">
              <div className="widget contact-widget">
                <div className="widget-title">
                  <h5>Contact Us</h5>
                </div>
                <ul>
                  {/* <li>
                    <img src={News2} alt="" />
                    <span>Chennai, India.</span>
                  </li>
                  <li>
                    <img src={News2} alt="" />
                    <span>Delaware, United States.</span>
                  </li> */}

                  <li>
                    <img src={Shape1} alt="" />
                    <span>info@tbiti.com</span>
                  </li>
                  <li>
                    <img src={News1} alt=""  /> <span>+91 44 4589 8141</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="wpo-lower-footer"
        style={{ paddingTop: 0, paddingBottom: 0 }}
      >
        <div
          className="container"
          style={{
            maxWidth: "100vw",
            paddingLeft: "0.5vw",
            paddingRight: "0.5vw",
          }}
        >
          <div className="row g-0">
            <div className="col-12 text-center">
              <p className="copyright" style={{ margin: 0 }}>
                Copyright © 2025 THINKBIG INFOTECH (INDIA) PRIVATE LIMITED.
              </p>
            </div>
            {/* <div className="col col-lg-6 col-12">
                            <ul>
                               
                                <li><Link onClick={ClickHandler} to="/about">About us</Link></li>
                            </ul>

                        </div>*/}
          </div>
        </div>
      </div>
      <style>{`
          @media (max-width: 600px) {
            .footer-logo {
              width: 50px !important;
            }
            .wpo-upper-footer .row > .col {
              min-width: 100vw !important;
              flex: 1 1 100vw !important;
              margin-bottom: 2px !important;
            }
            .wpo-upper-footer .container {
              padding-left: 0.5vw !important;
              padding-right: 0.5vw !important;
            }
          }
        `}</style>
    </footer>
  );
};

export default Footer;
